module.exports = __webpack_public_path__ + "static/newmember2-844723ec2b0cdb61e4297b46e43f4ce7.png";